/**
 * PC_GF_01
 * Importing the component, API and packages
 */
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
    Evaluation,
    getIndividualGoal,
    postGoal,
    updateGoal,
    directory,
    getTemplateCategoryDetails,
    goalLimit,
} from '../service/PerformanceAPI';
import Select from 'react-select';
import moment from 'moment';
import { connect } from 'react-redux';
//import '../containers/Goal/MyGoal.css'

import EvaluationPopUp from './EvaluationPopUp';
import BreadCrumbs from './BreadCrumbs/BreadCrumbs';
import Loader from '../StaticComponent/Loader';

import '../containers/Goal/GoalForm.css';
import { NotificationTrigger, OnlyNumberSpecialChar } from '../utils/RegHandling';
import _ from 'lodash';
import { encryptStorage } from '../constant';
import { getReportingEmpId } from '../service/DirectorAPI';

function GoalForm({ websocket }) {
    const { goalId } = useParams();
    const navigate = useNavigate();
    const { state } = useLocation();

    /**
     * PC_GF_02
     * State variables are created
     */

    let dataObj = {
        goalId: '',
        goal_name: '',
        description: '',
        assignedBy: '',
        assigned_by_id: '',
        assigned_to_id: '',
        assigned_to: '',
        goalType: '',
        assignedTo: [],
        evaluationPeriodId: '',
        goalTemplateId: '',
        employee_rating: '',
        employee_comments: '',
        manager_rating: '',
        manager_comments: '',
        status_id: '',
        evaluationStartDate: '',
        evaluationEndDate: '',
    };
    let details = { role: '', roleId: '', week: 0, domain: '' };
    const [userDetails, setUserDetails] = useState(details);
    const [pageMode, setPageMode] = useState(false);
    const [goalData, setGoalData] = useState(dataObj);
    const [showEmployee, setShowEmployee] = useState([]);
    const [selectedPeopleList, setSelectedPeopleList] = useState([]);
    const [emp, setEmp] = useState([]);
    const [reachedGoalLmit, setReachGoalLimit] = useState('');
    const [goalLimitPopUp, setGoalLimitPopUp] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [selectedListValidation, setselectedListValidation] = useState('');
    const [description, setdescription] = useState('');
    const [goalNameValidation, setgoalNameValidation] = useState('');
    const [breadCrumbsData, setbreadCrumbsData] = useState([]);
    const [oldSelectedValue, setOldSelectedValue] = useState([]);
    const [goalDataOld, setGoalDataOld] = useState(dataObj);

    const [disabledCheck, setDisabledCheck] = useState(false);
    /**
     * PC_GF_03
     * useEffect is invoked role is then loadGoalData function is called
     */

    /**
     * PC_GF_03
     * useEffect is invoked role is then loadGoalData function is called
     */

    useEffect(() => {
        if (encryptStorage.getItem('groupid') == 1 || encryptStorage.getItem('groupid') == 2 ) {
            userDetails.roleId = encryptStorage.getItem('employeeId');
        userDetails.role = encryptStorage.getItem('role') === 'Hr' ? 'Hr Manager' : encryptStorage.getItem('role');
        userDetails.domain = encryptStorage.getItem('department');

        loadGoalData();
        }else{
            navigate('/', { state: { hideNav: false } });
        }
        
    }, []);

    useEffect(() => {
        if (pageMode) {
            // let data = validation()

            let isSame = _.isEqual(goalData, goalDataOld);

            oldSelectedValue.filter((o1) => !selectedPeopleList.some((o2) => o1.value === o2.value)).length > 0
                ? setDisabledCheck(false)
                : isSame
                ? setDisabledCheck(true)
                : setDisabledCheck(false);
            // if (isSame) { setDisabledCheck(true) }
            // else if (!isSame) { setDisabledCheck(false) }
        }
    }, [goalData, goalDataOld, disabledCheck]);

    useEffect(() => {
        if (state?.View) {
            let breadcrumbsCreation = state?.profileBreadcrumbs;
            breadcrumbsCreation[breadcrumbsCreation.length - 1].title = goalData.goal_name;
            setbreadCrumbsData(breadcrumbsCreation);
        } else if (!goalId) {
            setbreadCrumbsData(
                userDetails.role == 'Manager'
                    ? [
                          { title: 'Dashboard', path: '/overview', isActive: true },
                          { title: 'Team Member', path: '', isActive: true },
                          { title: 'Performance', path: '/performance', isActive: true },
                          { title: `${goalData.goal_name}`, path: '', isActive: false },
                      ]
                    : userDetails.role == 'Hr Manager'
                    ? [
                          { title: 'Dashboard', path: '/overview', isActive: true },
                          { title: 'Team Member', path: '', isActive: true },
                          { title: 'Performance', path: '/performance', isActive: true },
                          { title: `${goalData.goal_name}`, path: '', isActive: false },
                      ]
                    : null
            );
        }
    }, [goalData]);

    const loadGoalData = async () => {
        
        if (goalId) {
            setbreadCrumbsData(
                userDetails.role == 'Manager'
                    ? [
                          { title: 'Dashboard', path: '/overview', isActive: true },
                          { title: 'Team Member', path: '', isActive: true },
                          { title: 'Performance', path: '/performance', isActive: true },
                          { title: 'Edit Goal', path: '', isActive: false },
                      ]
                    : userDetails.role == 'Hr Manager'
                    ? [
                          { title: 'Dashboard', path: '/overview', isActive: true },
                          { title: 'Team Member', path: '', isActive: true },
                          { title: 'Performance', path: '/performance', isActive: true },
                          { title: 'Edit Goal', path: '', isActive: false },
                      ]
                    : null
            );

            setIsLoading(false);
            getIndividualGoal({ goalId: goalId })
                .then((res) => {
                    if (res.data.ResponseData.length > 0) {
                        let objresponse;

                        if (res.data.ResponseData[0]?.assigned_to) {
                            objresponse = {
                                value: res.data.ResponseData[0]?.assigned_to_id,
                                // img: "/Images/logo-person-user-person-icon.jpg",
                                label: res.data.ResponseData[0]?.assigned_to,
                                username: res.data.ResponseData[0]?.assigned_to,
                            };
                        } else {
                            objresponse = {
                                value: res.data.ResponseData[0]?.team_name,
                                // img: "/Images/logo-person-user-person-icon.jpg",
                                label: res.data.ResponseData[0]?.team_name,
                                username: res.data.ResponseData[0]?.team_name,
                            };
                        }

                        let individualData = {
                            goalId: goalId,
                            goal_name: res.data.ResponseData[0]?.goal_name,
                            assigned_by_id: res.data.ResponseData[0]?.assigned_by_id,
                            assignedBy: res.data.ResponseData[0]?.assigned_by,
                            assigned_to_id: res.data.ResponseData[0]?.assigned_to_id,
                            assigned_to: [objresponse],
                            description: res.data.ResponseData[0]?.description,
                            evaluationStartDate: res.data.ResponseData[0]?.start_date,
                            evaluationEndDate: res.data.ResponseData[0]?.end_date,
                            progress: res.data.ResponseData[0]?.progress,
                            employee_rating: res.data.ResponseData[0]?.employee_rating,
                            employee_comments: res.data.ResponseData[0]?.employee_comments,
                            manager_rating: res.data.ResponseData[0]?.manager_rating,
                            manager_comments: res.data.ResponseData[0]?.manager_comments,
                            status_id: res.data.ResponseData[0]?.status_id,
                            goalType: res.data.ResponseData[0]?.goal_type,
                        };

                        

                        let result = res.data.ResponseData[0]?.goal_type === 'team' ? bind('team') : bind('');
                        setSelectedPeopleList([objresponse]);
                        setOldSelectedValue([objresponse]);
                        // handleChange([objresponse])
                        setGoalData({ ...individualData });
                        setGoalDataOld({ ...individualData });
                        setPageMode(true);
                        setIsLoading(true);
                    }
                    setIsLoading(true);
                })
                .catch((error) => {});
        } else if (state?.templateId) {
            let result = state?.type === 'team' ? bind('team') : bind('');
            setIsLoading(false);
            let evaluationResponse = await Evaluation({ currentEvaluation: 'jh' });
            if (evaluationResponse.data.ResponseData.length > 0) {
                goalData.evaluationPeriodId = evaluationResponse.data.ResponseData[0].id;
                goalData.evaluationStartDate = evaluationResponse.data.ResponseData[0].start_date;
                goalData.evaluationEndDate = evaluationResponse.data.ResponseData[0].end_date;
                setGoalData({ ...goalData });

                getTemplateCategoryDetails({ category_id: '', id: state.templateId }).then((res) => {
                    // let individualData = {
                    goalData.goalTemplateId = res.data.ResponseData.template[0].id;
                    goalData.goal_name = res.data.ResponseData.template[0].name;
                    goalData.description = res.data.ResponseData.template[0].description;
                    goalData.goalType = state.type !== undefined ? state.type : 'individual';
                    // };

                    
                    setGoalData({ ...goalData });
                });
            }

            setIsLoading(true);
        }
    };

    const OnChangeName = (e) => {
        setGoalData({ ...goalData, [e.target.name]: e.target.value });
    };

    const bind = async (value) => {
        let empResult;
        if (value === 'team') {
            empResult = await directory({ domain: 'domain' });
        } else if (userDetails.role == 'Hr Manager') {
            empResult = await directory({});
        } else {
            empResult = await directory({ empId: userDetails.roleId });
        }
        let samplearray = [];
        let selectedarray = [];
        let temparray = empResult.data.ResponseData.emplist;
        for (let i = 0; i <= temparray.length - 1; i++) {
            let objresponse = {
                value: temparray[i].emp_id,
                // img: "/Images/logo-person-user-person-icon.jpg",
                label: temparray[i].emp_name,
                username: temparray[i].emp_name,
            };
            if (state?.employeeId == temparray[i].emp_id) {
                selectedarray.push(objresponse);
            } else samplearray.push(objresponse);
        }
        setShowEmployee(samplearray);
        if (selectedarray.length > 0) {
            let attend = [];
            setSelectedPeopleList(selectedarray);
            selectedarray.map((data) => {
                attend.push(data?.value);
            });
            setEmp(attend);
            setGoalData({ ...goalData, ['assigned_to']: selectedarray });
        }
    };

    const handleChange = (e) => {
        let selectedValue = [];
        let attend = [];
        selectedValue = e;
        e.map((data) => {
            attend.push(data.value);
        });
        setSelectedPeopleList(selectedValue);
        setEmp(attend);
        setGoalData({ ...goalData, ['assigned_to']: selectedValue });
    };

    const goalCheck = async () => {
        if (selectedPeopleList.length > 0) {
            let obj = {
                empId: selectedPeopleList,
                evaluationPeriodId: goalData.evaluationPeriodId,
            };

            let limitResult = await goalLimit(obj);

            if (limitResult?.data?.ResponseData?.length > 0 && limitResult?.data?.ResponseData !== undefined) {
                let employeesName = limitResult?.data?.ResponseData?.join(' ,');
                setReachGoalLimit(employeesName);
                setGoalLimitPopUp(true);

                return false;
            }
        }
        return true;
    };

    const Validation = async () => {
        let result = true;
        if (selectedPeopleList.length == 0) {
            result = false;
            setselectedListValidation('Assigned to is required');
        } else if (goalData.goalType == 'individual') {
            let value = await goalCheck();
            if (!value) {
                setselectedListValidation('Assigned to is required');
                return false;
            }
        }
        if (goalData.goal_name.trim() == '') {
            result = false;
            setgoalNameValidation('Title is required');
        } else {
            let checkregex = OnlyNumberSpecialChar(goalData.goal_name);
            if (checkregex) {
                result = false;
                setgoalNameValidation('Please enter a valid title');
            } else {
                setgoalNameValidation('');
            }
        }
        if (goalData.description == '') {
            result = false;
            setdescription('Description is required');
        } else {
            let checkregex = OnlyNumberSpecialChar(goalData.description);
            if (checkregex) {
                result = false;
                setdescription('Description is not valid');
            } else {
                setdescription('');
            }
        }
        return result;
    };

    const closePopUp = (value) => {
        if (value) {
            setGoalLimitPopUp(!goalLimitPopUp);
        }
    };

    const goalSubmit = async () => {
        let value = await Validation();
        if (value) {
            if (pageMode) {
                setIsLoading(false);

                goalData.assigned_to_id = emp;
                setGoalData({ ...goalData });
                let obj = {
                    goalId: goalId,
                    goal_name: goalData.goal_name,
                    description: goalData.description,
                    progress: goalData.progress,
                    employee_rating: goalData.employee_rating,
                    employee_comments: goalData.employee_comments,
                    manager_rating: goalData.manager_rating,
                    manager_comments: goalData.manager_comments,
                    status_id: goalData.status_id,
                };

                let updateResponse = await updateGoal(obj);
                if (updateResponse.data.ResponseData == 'Successfully updated') {
                    await NotificationTrigger(
                        {
                            title: 'Goal',
                            message: `A goal  has been updated`,
                            route: `/goalview/${goalId}`,
                            state: { state: { role: 'Team Member' } },
                            to_employee: goalData.assigned_to_id,
                            by: userDetails.roleId,
                        },
                        goalData.assigned_to_id,
                        websocket
                    );
                    !state?.View
                        ? navigate('/performance', { state: { showSuccessPopup: true } })
                        : state?.redirect?.includes('tab')
                        ? (window.location.href = `/profilecontainer${state?.redirect?.split('tab')[0]}tab=performance`)
                        : (window.location.href = `/profilecontainer${state.redirect}&tab=performance`);
                    setIsLoading(true);
                }
            } else {
                setIsLoading(false);
                let postData = {
                    goalTitle: goalData.goal_name,
                    goalDescription: goalData.description,
                    goalType: goalData.goalType,
                    evaluationPeriodId: goalData.evaluationPeriodId,
                    goalTemplateId: goalData.goalTemplateId,
                    assignedTo: emp,
                    assignedBy: userDetails.roleId,
                };

                let postResponse = await postGoal(postData);
                if (postResponse.data.ResponseData.Message == 'Successfully inserted') {
                    if (goalData.goalType === 'individual') {
                        postResponse.data.ResponseData.goalId.map(async (eachId, i) => {
                            await NotificationTrigger(
                                {
                                    title: 'Goal',
                                    message: 'A goal is assigned ',
                                    route: `/goalview/${eachId.id}`,
                                    state: { state: { role: 'Team Member' } },
                                    to_employee: [postResponse.data.ResponseData.notifyTo[i]],
                                    by: userDetails.roleId,
                                },
                                [postResponse.data.ResponseData.notifyTo[i]],
                                websocket
                            );
                        });
                    } else {
                        postResponse.data.ResponseData.ids.map(async (eachId, i) => {
                            await NotificationTrigger(
                                {
                                    title: 'Goal',
                                    message: 'A goal is assigned ',
                                    route: `/goalview/${eachId}`,
                                    state: { state: { role: 'Team Member' } },
                                    to_employee: [postResponse.data.ResponseData.notifyTo[i]],
                                    by: userDetails.roleId,
                                },
                                [postResponse.data.ResponseData.notifyTo[i]],
                                websocket
                            );
                        });
                    }

                    !state?.View
                        ? navigate('/performance', { state: { showSuccessPopup: true } })
                        : state?.redirect?.includes('tab')
                        ? (window.location.href = `/profilecontainer${state?.redirect?.split('tab')[0]}tab=performance`)
                        : (window.location.href = `/profilecontainer${state.redirect}&tab=performance`);
                    setIsLoading(true);
                }
            }
        }
    };

    const ChangeTemplateClick = () => {
        navigate('/goalTemplate', { state: { ...state, type: state.type } });
    };

    return (
        <>
            {goalLimitPopUp ? (
                <EvaluationPopUp
                    Page={'GoalLimit'}
                    Heading={reachedGoalLmit + ` had reached their goal limit`}
                    Click={closePopUp}
                    GoalId={goalId}
                />
            ) : null}
            <Loader isLoading={isLoading} />
            <div className="container-fluid coverpic mt-5">
                <div className="row justify-content-center ">
                    <div className="col-md-8 px-4 py-4 goalform-container">
                        <BreadCrumbs data={breadCrumbsData} />
                        {/*Form structure starts Here*/}
                        <form>
                            <div className="mb-3">
                                <div className="d-flex justify-content-between">
                                    <label htmlFor="GoalTitle" className="form-label hive-form-label">
                                        <span>
                                            <img src="/Images/goal.png" className="icon-style me-2" alt="icon" />
                                        </span>
                                        Goal Title<span className="hive-form-mandatory">*</span>
                                    </label>
                                    {pageMode ? null : (
                                        <a
                                            onClick={() => {
                                                ChangeTemplateClick();
                                            }}
                                            className="font-14 bold-text text-decoration-none"
                                        >
                                            Change Template
                                        </a>
                                    )}
                                </div>
                                <div>
                                    <input
                                        maxLength={255}
                                        type="text"
                                        className="form-control hive-form-control"
                                        name="goal_name"
                                        value={goalData.goal_name}
                                        onChange={(e) => {
                                            setgoalNameValidation('');
                                            OnChangeName(e);
                                        }}
                                        id="GoalTitle"
                                        placeholder="Enter the goal title"
                                    />
                                    <label className="text-danger">{goalNameValidation} </label>
                                </div>
                            </div>
                            <div className="mb-3">
                                <label className="form-label hive-form-label" htmlFor="description">
                                    Add a Description
                                </label>
                                <textarea
                                    maxLength={5000}
                                    className="form-control hive-form-control hive-goal-form-resize"
                                    name="description"
                                    value={goalData.description}
                                    onChange={(e) => {
                                        setdescription('');
                                        OnChangeName(e);
                                    }}
                                    id="description"
                                    placeholder="Enter the description "
                                    rows={3}
                                />
                                <label className="text-danger">{description} </label>
                            </div>

                            <div className="mb-3 col-md-4 mt-4">
                                <label className="form-label hive-form-label" htmlFor="assignto">
                                    Assign to <span className="hive-form-mandatory">*</span>
                                </label>
                                {/* <input type="text" className="form-control hive-form-control" id="assignto" value={goalData.assigned_to_id}
                                        onChange={(e) => { OnChangeName(e) }} placeholder="Select" /> */}

                                <Select
                                    className="dropdown"
                                    name="assigned_to_id"
                                    maxMenuHeight={150}
                                    placeholder="Select"
                                    value={selectedPeopleList}
                                    options={showEmployee} // set list of the data
                                    onChange={(e) => {
                                        setselectedListValidation('');
                                        handleChange(e);
                                    }} // assign onChange function
                                    isMulti
                                    isClearable
                                />
                                <label className="text-danger">{selectedListValidation} </label>
                            </div>

                            <div className="mb-3 mt-5">
                                <label className="form-label hive-form-label w-100">Evaluation Period</label>
                                <label className="form-label font-15 semibold-text goalform-eval-color">
                                    {moment(goalData.evaluationStartDate).format('MMM,YYYY')} -
                                    {moment(goalData.evaluationEndDate).format('MMM,YYYY')}
                                </label>
                            </div>
                            <div className="col-md-12  d-flex justify-content-end mt-5 mb-4">
                                <a
                                    href={
                                        !state?.View
                                            ? '/performance'
                                            : state?.redirect?.includes('tab')
                                            ? `/profilecontainer${state?.redirect?.split('tab')[0]}tab=performance`
                                            : `/profilecontainer${state.redirect}&tab=performance`
                                    }
                                >
                                    <button type="button" className="btn hive-btn-secondary me-3">
                                        Cancel
                                    </button>
                                </a>
                                <button
                                    disabled={disabledCheck}
                                    type="button"
                                    className="btn hive-btn-primary"
                                    onClick={() => {
                                        goalSubmit();
                                    }}
                                >
                                    Assign a Goal
                                </button>
                            </div>
                        </form>
                        {/*Form structure ends Here*/}
                    </div>
                </div>
            </div>
        </>
    );
}

function mapStateToProps(state) {
    return {
        websocket: state.webSocketAPI,
    };
}

export default connect(mapStateToProps)(GoalForm);
